import { render, staticRenderFns } from "./TemplatesManagerModal.vue?vue&type=template&id=5eddf246&"
import script from "./TemplatesManagerModal.vue?vue&type=script&lang=js&"
export * from "./TemplatesManagerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports